import { render, staticRenderFns } from "./WarrantyTooltip.vue?vue&type=template&id=45bd486f&scoped=true"
import script from "./WarrantyTooltip.vue?vue&type=script&lang=js"
export * from "./WarrantyTooltip.vue?vue&type=script&lang=js"
import style0 from "./WarrantyTooltip.vue?vue&type=style&index=0&id=45bd486f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bd486f",
  null
  
)

export default component.exports